// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".round[data-v-1f5a5ca8]{border-radius:50%;border:1px solid var(--v-textColor-base)}.wallet-icon[data-v-1f5a5ca8]{width:20px;margin-left:12px}.wallet-icon.small[data-v-1f5a5ca8]{width:16px}", ""]);
// Exports
module.exports = exports;
